import { useCallback } from "react";

import sendGtmEvent from "web/utils/system/GTM/sendGtmEvent";

import { IBanner } from "web/types/Banners";

const usePromotionAnalytics = (bannerList: IBanner[], mobile: boolean) => {
  const promoData =
    bannerList?.map(
      ({
        graphics_title: title,
        graphics_alt: alt,
        img_mobile: imgMobile,
        img,
        position,
      }) => {
        return {
          name: title || alt || "",
          creative: mobile ? imgMobile : img,
          position: position || "",
        };
      }
    ) || [];

  const promoViewData = {
    ecommerce: {
      promoView: {
        promotions: promoData,
      },
    },
  };

  const promoClickData = {
    ecommerce: {
      promoClick: {
        promotions: promoData,
      },
    },
  };

  const onPromoClick = useCallback(() => {
    sendGtmEvent("promotionClick", promoClickData);
  }, [promoClickData]);

  return {
    promoViewData,
    onPromoClick,
  };
};

export default usePromotionAnalytics;
